/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { createInstance, getInstance } from '@module-federation/runtime';
import type { ModuleFederation } from '@module-federation/runtime';

// @ts-expect-error virtual module generated by @module-federation/vite
// eslint-disable-next-line import-x/no-extraneous-dependencies
import mfRuntimeInit from '__mf__virtual/newo_mf_2_builder_mf_2_host__mf_v__runtimeInit__mf_v__.js';

const MODULE_FEDERATION_HOST_NAME = 'newo-builder-host';
let mfHostInitPromise: Promise<ModuleFederation> | undefined;
const registeredRemotes = new Set<string>();

type InitMfPayload = {
    remoteSourceName: string;
    remoteSourceUrl: string;
};

type MfRuntimeInitModule = {
    initPromise: Promise<ModuleFederation>;
};

async function validateManifest(url: string) {
    try {
        const response = await fetch(url, { method: 'GET', cache: 'no-cache' });
        if (!response.ok) {
            return false;
        }
        const manifest = await response.json();
        return manifest && typeof manifest === 'object' && 'name' in manifest;
    } catch {
        return false;
    }
}

const createMfHostInstance = async () => {
    const existingInstance = getInstance();
    if (existingInstance) {
        return existingInstance;
    }

    const runtimeInitPromise = (mfRuntimeInit as Partial<MfRuntimeInitModule>)
        ?.initPromise;

    if (runtimeInitPromise) {
        const runtimeInstance = await runtimeInitPromise;
        if (runtimeInstance) {
            return runtimeInstance;
        }
    }

    return createInstance({
        name: MODULE_FEDERATION_HOST_NAME,
        remotes: []
    });
};

export async function waitForMfHostInit() {
    if (!mfHostInitPromise) {
        mfHostInitPromise = createMfHostInstance();
    }

    return mfHostInitPromise;
}

export async function initMF(payload: InitMfPayload) {
    const instance = await waitForMfHostInit();

    if (!registeredRemotes.has(payload.remoteSourceName)) {
        const candidateManifest = `${payload.remoteSourceUrl}/mf-manifest.json`;
        const isValid = await validateManifest(candidateManifest);

        if (!isValid) {
            throw new Error(
                `MF: Invalid manifest at ${candidateManifest} for ${payload.remoteSourceName}`
            );
        }

        instance.registerRemotes(
            [{ name: payload.remoteSourceName, entry: candidateManifest }],
            { force: true }
        );

        registeredRemotes.add(payload.remoteSourceName);
    }

    return instance;
}
